import { useId } from 'react';
export { UIDReset as GenerateIdProvider } from 'react-uid';

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var assignRef = function assignRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    try {
      // eslint-disable-next-line no-param-reassign
      ref.current = value;
    } catch (error) {
      throw new Error("Cannot assign value \"" + value + "\" to ref \"" + ref + "\"");
    }
  }
};
function useForkedRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  if (refs.every(function (ref) {
    return ref == null;
  })) {
    return null;
  }
  return function (node) {
    refs.forEach(function (ref) {
      assignRef(ref, node);
    });
  };
}
var isElement = function isElement(element) {
  var E = typeof Element === 'undefined' ? function E() {} : Element;
  return element instanceof E;
};
var contains = function contains(parent, element) {
  if (isElement(parent) && isElement(element)) {
    return parent.contains(element);
  }
  return false;
};
function wrapEvent(theirHandler, ourHandler) {
  return function (event) {
    if (theirHandler) {
      theirHandler(event);
    }
    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
    return undefined;
  };
}
var useGeneratedId = function useGeneratedId(namespace) {
  if (namespace === void 0) {
    namespace = 'generated';
  }
  var id = useId();
  return namespace + "-" + id;
};

export { assignRef, canUseDOM, contains, isElement, useForkedRef, useGeneratedId, wrapEvent };
